export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  coverImage: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'composition',
    name: '自拍构图',
    description: '掌握手机自拍构图的核心法则，从三分法到引导线，让你的每一张自拍都充满艺术感。',
    icon: 'ri-focus-3-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20photography%20composition%20with%20geometric%20grid%20lines%20overlay%20on%20a%20minimalist%20portrait%2C%20warm%20golden%20tones%2C%20clean%20cream%20background%2C%20rule%20of%20thirds%20illustration%2C%20elegant%20and%20modern%20photography%20aesthetic%2C%20soft%20diffused%20lighting%2C%20professional%20studio%20vibe&width=800&height=500&seq=cat-composition&orientation=landscape',
    articleCount: 24,
  },
  {
    slug: 'lighting',
    name: '光线运用',
    description: '深入理解自然光与人造光的奥秘，学习如何利用光线塑造完美自拍效果。',
    icon: 'ri-sun-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20golden%20sunlight%20streaming%20through%20a%20window%20creating%20beautiful%20shadows%20and%20highlights%20on%20a%20minimalist%20interior%20setting%2C%20soft%20natural%20light%20photography%20concept%2C%20cream%20and%20beige%20tones%2C%20elegant%20atmospheric%20mood%2C%20professional%20lighting%20tutorial%20aesthetic&width=800&height=500&seq=cat-lighting&orientation=landscape',
    articleCount: 18,
  },
  {
    slug: 'editing',
    name: '后期修图',
    description: '从基础调色到高级精修，系统学习手机修图技巧，让自拍作品更上一层楼。',
    icon: 'ri-image-edit-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20photo%20editing%20workspace%20with%20color%20grading%20tools%20displayed%20on%20screen%2C%20minimalist%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20before%20and%20after%20photo%20comparison%2C%20clean%20aesthetic%2C%20soft%20cream%20background%2C%20professional%20retouching%20concept&width=800&height=500&seq=cat-editing&orientation=landscape',
    articleCount: 31,
  },
  {
    slug: 'sharing',
    name: '达人分享',
    description: '聆听自拍达人的成长故事与实战经验，获取独家拍摄心得与创意灵感。',
    icon: 'ri-user-star-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Community%20of%20photography%20enthusiasts%20sharing%20and%20discussing%20photos%20together%20in%20a%20bright%20modern%20space%2C%20warm%20atmosphere%2C%20creative%20collaboration%2C%20minimalist%20interior%20with%20natural%20light%2C%20friendly%20vibe%2C%20artistic%20lifestyle%20photography&width=800&height=500&seq=cat-sharing&orientation=landscape',
    articleCount: 15,
  },
  {
    slug: 'equipment',
    name: '器材推荐',
    description: '精选手机摄影配件与自拍装备评测，帮你找到最适合的创作工具。',
    icon: 'ri-camera-lens-line',
    coverImage: 'https://readdy.ai/api/search-image?query=Phone%20photography%20accessories%20and%20equipment%20beautifully%20arranged%20on%20a%20minimalist%20wooden%20surface%2C%20tripod%20lens%20and%20lighting%20gear%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20product%20photography%20style%2C%20elegant%20lifestyle%20setup&width=800&height=500&seq=cat-equipment&orientation=landscape',
    articleCount: 12,
  },
];